"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentHeight = void 0;
var _useWindowDimensions2 = require("../useWindowDimensions/useWindowDimensions");
/**
 * Use this hook to get changes in viewport height. Useful when trying to
 * to implement responsiveness.
 *
 * @returns {number}
 */
var useCurrentHeight = exports.useCurrentHeight = function useCurrentHeight() {
  var _useWindowDimensions = (0, _useWindowDimensions2.useWindowDimensions)(),
    height = _useWindowDimensions.height;
  return height;
};